import Marquee from "react-fast-marquee";

const ITEMS = [
  "Nail Education",
  "Business Coaching",
  "Luxury Foot Care",
  "Beauty Products",
  "NY State Licensing",
];

export const EditorialMarquee = () => (
  <section data-testid="marquee-section" className="bg-brand-blush border-y border-brand-ink/10 py-7 md:py-9">
    <Marquee speed={30} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={`${item}-${i}`} className="flex items-center">
          <span className="font-serif italic font-light text-brand-ink text-3xl md:text-5xl tracking-tight px-8">
            {item}
          </span>
          <span className="text-brand-rose text-xl md:text-2xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
